import React from 'react';
import { useRoutes } from 'react-router-dom';
import { router } from '../routers';

const AllRouter = () => {
    const element = useRoutes(router)
    return (
        <>
         {element}   
        </>
    );
};

export default AllRouter;